"use client";

import { useState } from "react";
import { Menu } from "lucide-react";
import { trackEvent } from "@/lib/analytics";
import {
  SignedIn,
  SignedOut,
  UserButton,
  ClerkLoading,
  ClerkLoaded,
} from "@clerk/nextjs";

import Link from "next/link";
import { PersonOutline } from "@/components/icons";
import { SearchForm } from "./SearchForm";
import { MobileNavPanel } from "./MobileNavPanel";
import { ProfileSettingsPage } from "@/components/auth/ProfileSettingsPage";

const MobileFloatingBar = () => {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <>
      {/* Fixed bottom bar */}
      <div className="lg:hidden fixed bottom-4 left-0 right-0 z-50 flex justify-center px-4">
        <div className="flex items-center gap-1 w-full max-w-sm">
          {/* Left: User avatar circle */}
          <ClerkLoading>
            <div className="size-12 rounded-full bg-sun-100 animate-pulse flex-shrink-0" />
          </ClerkLoading>
          <ClerkLoaded>
            <SignedIn>
              <UserButton appearance={{ elements: { avatarBox: "size-12" } }}>
                <UserButton.MenuItems>
                  <UserButton.Action label="signOut" />
                </UserButton.MenuItems>
                <UserButton.UserProfilePage label="Dialetics" url="settings" labelIcon={<span>✏️</span>}>
                  <ProfileSettingsPage />
                </UserButton.UserProfilePage>
                <UserButton.UserProfilePage label="account" />
                <UserButton.UserProfilePage label="security" />
                <UserButton.UserProfileLink
                  label="Mitgliedschaft"
                  url="/user/membership"
                  labelIcon={
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.3333 2H2.66667C1.93029 2 1.33333 2.59695 1.33333 3.33333V12.6667C1.33333 13.403 1.93029 14 2.66667 14H13.3333C14.0697 14 14.6667 13.403 14.6667 12.6667V3.33333C14.6667 2.59695 14.0697 2 13.3333 2Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M1.33333 6H14.6667" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  }
                />
                <UserButton.UserProfileLink
                  label="Abmelden"
                  url="/sign-out"
                  labelIcon={
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  }
                />
              </UserButton>
            </SignedIn>
            <SignedOut>
              <Link
                href="/login"
                className="size-12 rounded-full bg-sun-100 flex items-center justify-center flex-shrink-0"
                aria-label="Anmelden"
                // Haeufigster Login-Einstieg auf dem Handy; CtaClickTracker meldet ihn.
                data-cta-location="mobile_floating_bar"
                data-cta-label="Anmelden"
              >
                <PersonOutline className="w-5 h-5" />
              </Link>
            </SignedOut>
          </ClerkLoaded>

          {/* Center: Search */}
          <SearchForm
            glassmorphism
            className="flex-1 min-w-0"
          />

          {/* Right: Hamburger circle */}
          <button
            onClick={() => {
              trackEvent("mobile_menu_opened");
              setNavOpen(true);
            }}
            className="size-12 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0"
            aria-label="Menü öffnen"
          >
            <Menu className="size-6 text-white" />
          </button>
        </div>
      </div>

      {/* Mobile nav panel */}
      <MobileNavPanel open={navOpen} onClose={() => setNavOpen(false)} />
    </>
  );
};

export { MobileFloatingBar };
